module.exports = __webpack_public_path__ + "static/media/CNBC_Logo_White.ded6f676.png";